module.exports = __webpack_public_path__ + "1d29f92e8fc3332997244864231412a8.png";


//////////////////
// WEBPACK FOOTER
// ../assets/247edmonton-screen.png
// module id = 516
// module chunks = 0